(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yop-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yop-card-gallery')) {
    customElements.define('yop-card-gallery', class extends HTMLElement {
      connectedCallback() {
        this.teardown?.();
        const slides = [...this.querySelectorAll('[data-yop-slide]')];
        if (slides.length === 1) {
          this.querySelector('[data-yop-caption]').textContent = slides[0].dataset.caption;
          this.querySelector('[data-yop-price]').textContent = slides[0].dataset.price;
          this.querySelector('[data-yop-title-link]').href = slides[0].href;
        }
        if (slides.length < 2) return;
        const abort = new AbortController();
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        const pause = this.querySelector('[data-yop-pause]');
        const caption = this.querySelector('[data-yop-caption]');
        const count = this.querySelector('[data-yop-count]');
        const price = this.querySelector('[data-yop-price]');
        const titleLink = this.querySelector('[data-yop-title-link]');
        let index = 0;
        let paused = motion.matches;
        let visible = false;
        let hovering = false;
        let timer;
        const stop = () => clearInterval(timer);
        const show = (next) => {
          index = (next + slides.length) % slides.length;
          slides.forEach((slide, i) => { slide.hidden = i !== index; slide.classList.toggle('yop-slide-active', i === index); });
          caption.textContent = slides[index].dataset.caption;
          count.textContent = `${index + 1} / ${slides.length}`;
          price.textContent = slides[index].dataset.price;
          titleLink.href = slides[index].href;
        };
        const sync = () => {
          stop();
          pause.textContent = paused ? this.dataset.playLabel : this.dataset.pauseLabel;
          if (paused || !visible || hovering || document.hidden || this.contains(document.activeElement)) return;
          timer = setInterval(() => show(index + 1), 6000);
        };
        const listen = (target, name, fn) => target.addEventListener(name, fn, { signal: abort.signal });
        listen(this.querySelector('[data-yop-next]'), 'click', () => { paused = true; show(index + 1); sync(); });
        listen(this.querySelector('[data-yop-previous]'), 'click', () => { paused = true; show(index - 1); sync(); });
        listen(pause, 'click', () => { paused = !paused; sync(); });
        listen(this, 'mouseenter', () => { hovering = true; sync(); });
        listen(this, 'mouseleave', () => { hovering = false; sync(); });
        listen(this, 'focusin', sync);
        listen(this, 'focusout', () => queueMicrotask(sync));
        listen(document, 'visibilitychange', sync);
        listen(motion, 'change', () => { if (motion.matches) paused = true; sync(); });
        const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25; sync(); }, { threshold:0.25 });
        observer.observe(this);
        this.querySelector('[data-yop-controls]').hidden = false;
        show(0);
        sync();
        this.teardown = () => { stop(); abort.abort(); observer.disconnect(); };
      }
      disconnectedCallback() { this.teardown?.(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
